export async function importScriptModule(script) {
  const data = `data:text/javascript;base64,${btoa(script)}`
  return await import(/* webpackIgnore: true */ data);
}